/**
 * Declare all the Agent settings details
 */
export interface AgentSettings {
    webRTCType: string;
    webRTCWssUrls: Array<string>;
    webRTCServerDomain: string;
    webRTCIceUrls: Array<string>;
    webRTCDnis: string;
}
